import { useEffect, useState } from 'react';

// Creates a boolean which can be temporarily set to true, and will revert to false after the timeout
export const useTemporaryBoolean = (timeout = 2000): [boolean, () => void] => {
  const [state, setState] = useState(false);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    if (state) {
      const timeoutId = setTimeout(() => setState(false), timeout);
      return () => clearTimeout(timeoutId);
    }
  }, [timeout, state, version]);

  const setTrue = () => {
    setState(true);
    setVersion(version + 1); // This ensures that the timeout is restarted each time setTrue is called
  };

  return [state, setTrue];
};
